const renderBlock = (block: any) => {
    // const {
    //     data: { text },
    // } = block;
    return <div></div>;
};

export default renderBlock;
